import { Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import { VisitTypeStore } from "@app/services/store/visit-type-store";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl
} from "@angular/forms";
import { VisitStore } from "@app/services/store/visit-store";
import { ResourceStore } from "@app/services/store/resource-store";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { VisitTypeChooserDialogComponent } from "@app/view/shared/visit-type-chooser-dialog/visit-type-chooser-dialog.component";
import { Job } from "@app/models/rest/job";
import { Visit_DetailProjection } from "@app/models/rest/visit";
import { VisitType } from "@app/models/rest/visit-type";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { RouterLink, Router } from "@angular/router";
import { AsyncPipe } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { Ticket } from "@app/models/rest/ticket";
import { TicketStore } from "@app/services/store/ticket-store";
import { BookingNavigationService } from "@app/services/navigation/booking-navigation.service";

@Component({
  selector: "app-add-visit-dialog",
  templateUrl: "./add-visit-dialog.component.html",
  styleUrls: ["./add-visit-dialog.component.css"],
  imports: [
    MatToolbar,
    MatDialogTitle,
    MatToolbarRow,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    MatButton,
    MatInput,
    MatDialogClose,
    MatDialogActions,
    AsyncPipe,
    TranslatePipe
  ]
})
export class AddVisitDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddVisitDialogComponent>>(MatDialogRef);
  visitTypeStore = inject(VisitTypeStore);
  ticketStore = inject(TicketStore);
  visitStore = inject(VisitStore);
  protected dialog = inject(MatDialog);
  resourceStore = inject(ResourceStore);
  protected serviceErrorHandler = inject(ServiceErrorHandlerService);
  private router = inject(Router);
  private bookingNavigationService = inject(BookingNavigationService);
  data = inject<{
    job: Job;
    visit: Visit_DetailProjection;
    actionTicketId?: number;
  }>(MAT_DIALOG_DATA);

  VisitTypeList: UntypedFormControl = new UntypedFormControl();
  durationField: UntypedFormControl = new UntypedFormControl();
  public loading: boolean = true;
  public visitTypes: VisitType[];
  newVisitId: number;
  visitCreationDone = false;

  ngOnInit() {
    console.log(this.data.job);
    this.visitTypeStore.loadAll().then((visitTypes) => {
      this.visitTypes = visitTypes.resources;
      this.loading = false;
      if (this.data.visit) {
        console.log("setting visit type to ", this.data.visit.visitType);
        const visitType = visitTypes.resources.find(
          (value) => value.id === this.data.visit.visitType.id
        );
        if (visitType) {
          this.VisitTypeList.setValue(this.data.visit.visitType);
        }
      }
    });
  }

  addVisit() {
    // Validate duration is not negative
    const duration = this.durationField.value;
    if (duration == null || duration < 0) {
      this.serviceErrorHandler.handleClientError("Duration cannot be negative");
      return;
    }

    this.loading = true;
    this.visitStore
      .addNewVisit(this.data.job, this.VisitTypeList.value, duration)
      .then((value) => {
        console.log("visit created", value);
        this.newVisitId = value.id;
        this.visitCreationDone = true;
        if (this.data.actionTicketId) {
          this.clearFollowOn();
        }
      })
      .catch((reason) => {
        this.loading = false;
        this.serviceErrorHandler.handleError(reason);
      });
  }

  clearFollowOn() {
    this.ticketStore
      .loadSingle(this.data.actionTicketId)
      .then((storedTicket: Ticket) => {
        storedTicket.followOnActioned = true;
        this.ticketStore.update(storedTicket).subscribe(() => {});
      });
  }
  chooseVisitType() {
    const dialogRef2 = this.dialog.open(VisitTypeChooserDialogComponent, {
      width: "640px"
    });
    dialogRef2.afterClosed().subscribe((result) => {
      // afterClosed emits undefined when the dialog is dismissed (ESC/backdrop).
      if (!result) {
        return;
      }
      const visitType = this.visitTypes.find(
        (value) => value.id === result.data.id
      );
      console.log("The dialog was closed", result);
      if (visitType) {
        this.VisitTypeList.setValue(visitType);
      }
    });
  }

  bookNewVisit(): void {
    // Store the original route (job detail page) so booking can return here
    this.bookingNavigationService.setOriginalRoute(
      `/jobs/detail/${this.data.job.id}`
    );
    this.dialogRef.close();
    this.router.navigate(["/booking/visit/", this.newVisitId]);
  }
}
